import { useEffect } from "react";
import Hero from "../components/Blog/sections/HeroBlog";
import Featured from "../components/Blog/sections/Featured";
import Blogs from "../components/Blog/sections/Blogs";
import Newsletter from "../components/Blog/sections/Newsletter";

const BlogPage = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);

  return (
    <div className="min-h-screen bg-[--st-color-cream]">
      <Hero />
      <Featured />
      <Blogs />
      <Newsletter />
    </div>
  );
};

export default BlogPage;